import { useQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "@api/queryKeys";

import { similarDataApis } from "./dealsSimilarData.service";

export const getSimilarData = async (
  pressId: string,
  type: "deal" | "funding",
) => {
  const response = await similarDataApis.get(pressId, type);
  return response;
};

export const useSimilarDataQuery = (
  pressId: string,
  type?: "funding" | "deal",
) => {
  const similarDataType = type || "deal";
  return useQuery({
    queryKey: [QUERY_KEYS.similarData, pressId, similarDataType],
    queryFn: () => getSimilarData(pressId, similarDataType),
    select: (data) => data.detail,
    retry: false,
    throwOnError: false,
  });
};
